(function () {
    'use strict';

    angular.module("imApp").factory("timestampSettingsService", [function () {
        let service = {};

        return service;
    }]);
})();
